<p-card styleClass="shadow-sm">
  <p class="m-0 noti-tile">
    {{notification()?.message}}
  </p>
</p-card>